import React from 'react';

import { Product } from '../../../interfaces';
import { useStringArraySearchParam } from '../../../hooks';

interface Props {
  product: Product;
}

export default function InactiveIngredientTags(props: Props) {
  const { product } = props;
  const { otherIngredients } = product;
  const [, excludeInactiveIngredientsActions] = useStringArraySearchParam(
    '-otherIngredients'
  );

  if (!otherIngredients) {
    return null;
  }

  const otherIngredientSet = new Set<string>();
  const uniqueOtherIngredients: string[] = [];

  otherIngredients.forEach((otherIngredient) => {
    if (!otherIngredientSet.has(otherIngredient.toLowerCase().trim())) {
      otherIngredientSet.add(otherIngredient.toLowerCase().trim());
      uniqueOtherIngredients.push(otherIngredient.trim());
    }
  });

  const sortedUniqueOtherIngredients = uniqueOtherIngredients.sort();

  return (
    <div className="field is-grouped is-grouped-multiline">
      {sortedUniqueOtherIngredients.map((name) => (
        <div className="control" key={name}>
          <div className="tags has-addons">
            <span className="tag is-light" key={name}>
              {name}
            </span>
            <a
              className="tag is-delete"
              onClick={() =>
                excludeInactiveIngredientsActions.add(name.toLowerCase())
              }
            />
          </div>
        </div>
      ))}
    </div>
  );
}
